import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide10Contacts({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-226" data-mp="1gjnqb2zhpsxg">
      <SlideHeader eyebrow="12-Month Proposal" data-id="element-227" data-mp="1bkb1icp26bs8">
        12-month model: full annual engagement loop with better value
      </SlideHeader>

      <div className="flex-1 flex flex-col max-w-6xl mx-auto w-full relative" data-id="element-228" data-mp="2970aj6i6honl">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="absolute -top-16 right-0 bg-[var(--brand)] text-white px-4 py-2 rounded-full font-bold text-sm flex items-center gap-2 shadow-lg" data-id="element-229" data-mp="248f9j4v3r0y3">
          <Star className="h-4 w-4 fill-current" data-id="element-230" data-mp="iuue5tgapl2v" />
          RECOMMENDED
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-8 max-w-4xl" data-id="element-231" data-mp="2ws37b49kuudl">
          For a 12-month commitment, GSK receives a 10% discount on
          campaign adaptations and master updates. The discount does not apply
          to the initial master production.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border-2 border-[var(--brand)]/20 overflow-hidden" data-id="element-232" data-mp="2435tpegb9lr6">
          <table className="w-full text-left border-collapse" data-id="element-233" data-mp="5kaqynh2tvux">
            <thead data-id="element-234" data-mp="5lvnujqv5qvy">
              <tr className="bg-[var(--surface)] border-b border-black/5" data-id="element-235" data-mp="tucr15fm67i">
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-236" data-mp="sj9r3jt92hg">
                  Item
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-center" data-id="element-237" data-mp="3n1kf52au8vci">
                  Quantity
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-right" data-id="element-238" data-mp="oh2ghen7p77f">
                  Unit Price
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--brand)] uppercase tracking-wider text-right" data-id="element-239" data-mp="ejo01f1agif4">
                  Discounted Price
                </th>
                <th className="py-4 px-6 text-sm font-bold text-[var(--muted)] uppercase tracking-wider text-right" data-id="element-240" data-mp="2zbq4mrdzrivf">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-black/5" data-id="element-241" data-mp="1asn3nh5k6flu">
              <tr className="hover:bg-black/[0.02] transition-colors" data-id="element-242" data-mp="1aq0w3hio403m">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-243" data-mp="1etyxxzzdnp0d">
                  Master Teaser
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-244" data-mp="1jqp8y8wbruex">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)]" data-id="element-245" data-mp="1okjrh90723cf">
                  €2,500
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] text-sm" data-id="element-246" data-mp="1tkobva483i7x">
                  No discount
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-247" data-mp="22irtvwg01wuz">
                  €2,500
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors" data-id="element-248" data-mp="27g0e02kpkayv">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-249" data-mp="86ac34dxjoxq">
                  Master Trailer / Microsite
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-250" data-mp="d5woxcpuj360">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)]" data-id="element-251" data-mp="3dxgf3cwn35id">
                  €3,500
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] text-sm" data-id="element-252" data-mp="392kn2creki59">
                  No discount
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-253" data-mp="3iy4d4ijacmm3">
                  €3,500
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-254" data-mp="2v6p82i04jr75">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-255" data-mp="2qbjldgywe8i0">
                  Monthly campaign adaptations
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-256" data-mp="30863vz3r4ngv">
                  12
                </td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-257" data-mp="2chijwfgka7dy">
                  €600
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-258" data-mp="27ipezbfcbope">
                  €540
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-259" data-mp="mzda8kf7dtrq">
                  €6,480
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-260" data-mp="d41upzvz0iix">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-261" data-mp="i351ppvigytj">
                  Teaser Master Update
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-262" data-mp="15sh68cfw8ipi">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-263" data-mp="1apg332qxz3re">
                  €1,250
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-264" data-mp="wtcafdvpv3h1">
                  €1,125
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-265" data-mp="3hgp99ja82ozb">
                  €1,125
                </td>
              </tr>
              <tr className="hover:bg-black/[0.02] transition-colors bg-[var(--brand)]/5" data-id="element-266" data-mp="3lk53ya2qef9d">
                <td className="py-4 px-6 font-semibold text-[var(--fg)]" data-id="element-267" data-mp="1rzjz41glw42f">
                  Trailer / Microsite Master Update
                </td>
                <td className="py-4 px-6 text-center text-[var(--muted)]" data-id="element-268" data-mp="1ia0d4mxlju3c">1</td>
                <td className="py-4 px-6 text-right text-[var(--muted)] line-through" data-id="element-269" data-mp="1i7xddb6n6mlf">
                  €2,250
                </td>
                <td className="py-4 px-6 text-right font-bold text-[var(--brand)]" data-id="element-270" data-mp="19a4z8acnpkzm">
                  €2,025
                </td>
                <td className="py-4 px-6 text-right font-semibold text-[var(--fg)]" data-id="element-271" data-mp="149pir9x2vxdf">
                  €2,025
                </td>
              </tr>
            </tbody>
            <tfoot data-id="element-272" data-mp="ucumkxoa292b">
              <tr className="bg-[var(--brand)] text-white" data-id="element-273" data-mp="ude4wfhuazgv">
                <td colSpan={4} className="py-5 px-6 font-bold text-lg uppercase tracking-wider" data-id="element-274" data-mp="2tp6wfwluzcm7">
                  Total 12-month proposal
                </td>
                <td className="py-5 px-6 text-right font-bold text-2xl" data-id="element-275" data-mp="2x7wa8qpfwfr8">
                  €15,630
                </td>
              </tr>
            </tfoot>
          </table>
        </motion.div>
      </div>
    </InteriorSlide>;
}